
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '计量单位名称',
value: this.$route.params.Item.PU_Name
}, {
label: '代码说明',
value: this.$route.params.Item.PU_Remark
}]
}
}



// WEBPACK FOOTER //
// ./src/components/UnitsDetail.vue